import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import * as english from 'translations/english';
import * as japanese from 'translations/japanese';
import * as korean from 'translations/korean';

const getBrowserLanguage = () => {
  if (!navigator) {
    return 'en';
  }

  const lang = navigator.languages?.[0] || navigator.language || 'en';
  return lang.split('-')[0];
};

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: english,
    },
    ja: {
      translation: japanese,
    },
    ko: {
      translation: korean,
    },
  },
  lng: getBrowserLanguage(),
  fallbackLng: 'en',
  compatibilityJSON: 'v3', // By default React Native projects does not support Intl
  interpolation: {
    escapeValue: false, // leave special characters as is
  },
});

export default i18n;
